/*
 * ALL RIGHTS RESERVED,
 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
 */

import { AuthenticationService } from '../../common/authentication/service/AuthenticationService';
import { PjInjectProxy } from '../../common/extends_fw/PjInjectProxy';
import { PjBaseController } from '../../common/extends_fw/controller/PjBaseController';
import { PjServiceResponse } from '../../common/extends_fw/service/PjServiceResponse';
import { MsgLevel } from '../../framework/controller/MsgLevel';
import { DashboardService } from '../service/DashboardService';
import { LoginResult } from '../../common/authentication/dto/LoginResult';
import { SharedService } from '../../common/extends_fw/controller/PjBaseController';
import { NoticeListJson } from '../json/JsonAll';
import { NoticeCriteriaJson } from '../json/JsonAll';
import { AccessTransitionJson } from '../json/JsonAll';
import { RankJson } from '../json/JsonAll';
import { NoticeService } from '../service/NoticeService';

/**
 * ログイン画面について出力処理およびイベント処理を行う。
 */
export class DashboardController extends PjBaseController {

    /**
     * ユーザID
     */
    public userid: string;

    /**
     * パスワード
     */
    public password: string;

    /**
     * ロケール
     */
    public locale: string;

    /**
     * メッセージ TODO protectedに戻す
     */
    public message: string;

    /**
     * メッセージ種別 TODO protectedに戻す
     */
    public messageType: string;

    // グリッド情報(お知らせ)
    public gridOptions: any;

    // グリッド情報(再生数)
    public gridOptions2: any;

    // グリッド情報(ブックマーク)
    public gridOptions3: any;

    // グリッド情報(評価)
    public gridOptions4: any;

    // アクセスラベル
    public accessLabel: any[] = [];

    // アクセスカウント
    public accessCount: any[] = [];

    // チャートデータ
    public lineChartData: any;

    // チャート型
    public lineChartCanvas: any;

    /**
     * コンストラクタ
     * @param {angular.ui.IStateParamsService} $stateParams 画面間の引き継ぎデータ
     * @param {ng.IWindowService} $window Windowオブジェクト
     * @param {ng.ui.bootstrap.IModalService} $uibModal モーダル
     * @param {ng.translate.ITranslateService} $translate 多国語化部品サービス
     * @param {PjInjectProxy} pjInjectProxy インジェクタプロキシ
     * @param {AuthenticationService} authenticationService 認証サービス
     */
    /* @ngInject */
    public constructor(
            protected $stateParams: angular.ui.IStateParamsService,
            protected $window: ng.IWindowService,
            protected $uibModal: ng.ui.bootstrap.IModalService,
            protected $translate: ng.translate.ITranslateService,
            protected pjInjectProxy: PjInjectProxy,
            protected authenticationService: AuthenticationService,
            protected dashboardService: DashboardService,
            protected $location: ng.ILocationService,
            protected sharedService: SharedService,
            protected $scope: any) {
        super($stateParams, $translate, $location, pjInjectProxy);

        if (!this.checkAuthenticatedUser()) {
            return;
        }

        this.setTitle('form34.title');
        this.setMenu(true);
        this.draw();

        this.gridOptions = {
          columnDefs: [
            {
              field: 'title',
              displayName: '件名',
              cellTemplate: '<div class="ui-grid-cell-contents" style="padding:5px">' + '<a ng-click="grid.appScope.show(row.entity.id)">{{row.entity.title}}</a>' + '<div>'
            },
            {
              field: 'date',
              displayName: '公開開始日',
              width: '13%'
            }
          ],
          enableColumnMenus: false,
          enableHorizontalScrollbar: 0,
          enableColumnResizing: true,
        };

        this.gridOptions2 = this.getOptions();
        this.gridOptions3 = this.getOptions();
        this.gridOptions4 = this.getOptions();

        //  sharedService利用　role:利用者の強制ログアウト
        let auth: any;

        auth = sharedService.get('auth');
        //  権限が無いユーザはログインへ戻す
        if (auth) {
            if (!(auth.role === 2 || auth.role === 3 || auth.role === 4)) {
                this.$location.url('/');
            }
        }
        this.getNotice();
        this.getRanking('1', this.gridOptions2);
        this.getRanking('2', this.gridOptions3);
        this.getRanking('3', this.gridOptions4);

        this.getAccess();
        $scope.getColumnDefs = this.getColumnDefs;

        this.$scope.show = (id: string) => {
            return this.show_dialog(id);
        };
    }

    /**
     * ダイアログ表示
     */
    public show_dialog(id: string = null): void {
        let test: any = this.$uibModal.open({
            templateUrl: 'template/notice/detail.html',
            controller: 'noticeEditController',
            controllerAs: 'noticeEdit',
            resolve: {
                id: function (): string {
                    return id;
                }
            },
        }).result.then((result: string) => {
            if (result) {
            }
        });
    }

    public getNotice(): void {
        let criteria: any = {
            dateFlg: 1
        };
        this.dashboardService.getNotice(criteria).then((data: any) => {
            if (data.status === 204) {
                this.$scope.viewNotice = false;
            } else {
                if (this.gridOptions.data === undefined || this.gridOptions.data === null) {
                    this.gridOptions.data = data.data.notices;
                } else {
                    this.gridOptions.data.splice(0, this.gridOptions.data.length);
                    Array.prototype.push.apply(this.gridOptions.data, data.data.notices);
                }
                this.$scope.viewNotice = true;
            }
        }).catch((errorData: any) => {
            this.catch(errorData);
        });
    }

    public getOptions(): any {
        return {
          columnDefs: [
            {
              field: 'rank',
              displayName: '順位',
              cellTemplate: '<div class="ranking {{grid.appScope.getColumnDefs(row.entity.rank)}}">{{row.entity.rank}}</div>',
              width: '27%'
            },
            {
              field: 'title',
              displayName: '動画名',
            }
          ],
          enableColumnMenus: false,
          enableHorizontalScrollbar: 0,
          enableColumnResizing: true,
        };
    }

    public getColumnDefs(rank: any): any {
        if (rank == 1) {
            return 'rankImg';
        } else {
            return '';
        }
    }

    public getRanking(id: string, gridOption: any): void {
        this.dashboardService.getRanking(id).then((data: any) => {
            if (data.status === 204) {
                if (id === '1') {
                    this.$scope.viewStart = false;
                } else if (id === '2') {
                    this.$scope.viewBookmark = false;
                } else {
                    this.$scope.viewEvaluation = false;
                }
            } else {
                if (gridOption.data === undefined || gridOption.data === null) {
                    gridOption.data = data.data.rankings;
                } else {
                    gridOption.data.splice(0, gridOption.data.length);
                    Array.prototype.push.apply(gridOption.data, data.data.rankings);
                }
                if (id === '1') {
                    this.$scope.viewStart = true;
                } else if (id === '2') {
                    this.$scope.viewBookmark = true;
                } else {
                    this.$scope.viewEvaluation = true;
                }
            }
        }).catch((errorData: any) => {
            this.catch(errorData);
        });
    }

    public getAccess(): void {
        this.dashboardService.getAccess().then((data: any) => {
            if (data.status === 204) {
                this.$scope.viewAccess = false;
            } else {
                let lineChartCanvas: any = (<any> $('#lineChart')[0]).getContext('2d');
                let strCount: any;
                if (data.data.ranking) {
                    strCount = data.data.ranking.count.split(',');
                    let numCount: number[] = [];
                    for (let i: number = 0; i < strCount.length; i++) {
                        numCount.push(Number(strCount[i]));
                    }
                    this.lineChartData = {
                        labels: data.data.ranking.date,
                        datasets: [
                            {
                              label: 'アクセス数',
                              // fillColor: 'rgba(60,141,188,0.9)',
                              borderColor: 'rgba(60,141,188,0.8)',
                              fill: false,
                              pointRadius: 0,
                              pointHitRadius: 10,
                              data: numCount,
                            }
                        ]
                    };

                    let lineChartOptions: any = {
                        responsive: true,
                        legend: {
                           display: false
                        },
                        scales : {
                            xAxes: [{
                              ticks: {
                                autoSkip: false,
                              },
                              gridLines: {
                                display: false,
                              },
                            }],
                            yAxes: [{
                              ticks: {
                                min: 0,
                                userCallback: function(label: any, index: any, labels: any): any {
                                  if (Math.floor(label) === label) {
                                    return label;
                                  }
                                },
                              },
                              gridLines: {
                                display: false,
                              },
                            }]
                        }
                    };
                    if (data.data.result == 0) {
                        lineChartOptions.scales.yAxes[0].ticks.max = 1;
                    }
                let lineChart: any = new Chart.Line(lineChartCanvas, {
                    data: this.lineChartData,
                    options: lineChartOptions
                });
                this.$scope.viewAccess = true;
                }
            }
        }).catch((errorData: any) => {
            this.catch(errorData);
        });
    }

    /**
     * 復元処理
     * @param {any} data 復元用データ
     */
    public restore(
            data: any): void {
    }

    /**
     * 表示処理
     */
    public show(): void {
    }
}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/ma/controller/DashboardController.ts
 **/